// @ts-nocheck
import React from 'react';

const PresentationDeleteAlert = React.lazy(
  () => import('@/containers/Alerts/Presentations/PresentationDeleteAlert'),
);

/**
 * Presentations alert list.
 */
export default [
  {
    name: 'presentation-delete',
    component: PresentationDeleteAlert,
  },
];
